<template>
  <div class="wrapper" @click="openEOrder">
    <img :src="imgSrc" alt="chatbot" />
    <div class="text-content-wrapper">
      <div class="text-content">
        <VueText sizeLevel="7" weightLevel="2">Ön-Sipariş Ver</VueText>
      </div>
    </div>
  </div>
</template>
<script>
import VueText from 'VueText';
import gtmUtils from '@/mixins/gtmUtils.js';
import preOrderUtils from '@/mixins/preOrderUtils.js';

export default {
  name: 'ButtonPreOrder',
  components: {
    VueText,
  },
  mixins: [gtmUtils, preOrderUtils],
  computed: {
    imgSrc() {
      return require('../../../assets/button/preorder-cart.svg');
    },
  },
  methods: {
    openEOrder() {
      this.handlePreOrderRedirect('sidebar');
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: bottom;
  background: url('~@/assets/button/preorder-bg.svg');
  margin-bottom: palette-space-level(10) !important;
  background-repeat: no-repeat;
  background-position-y: bottom;
  cursor: pointer;
  > img {
    margin-left: palette-space-level(8) !important;
  }
  .text-content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: palette-space-level(20);
    padding-left: palette-space-level(10);
    .text-content {
      display: flex;
      flex-direction: row;
      user-select: none;
      color: #fff;
      p {
        &:first-child {
          margin-bottom: palette-space-level(3);
        }
      }
    }
  }
}
</style>
